import { IdwFormLabelWithIconContainer } from '@containers/common/idw-form-label-with-icon-container/idw-form-label-with-icon-container';
import { LabelWidthTypes } from '@enums/label-width-types';
import { LayoutTypes } from '@enums/layout-types';

export interface IdwFormLabelWithIconContainerProps {
    label: string;
    controlId: string;
    isRequired: boolean;
}

export const AXNUIThemingLabelComponent = ({
    label,
    controlId,
    isRequired
}: IdwFormLabelWithIconContainerProps) => (
    <IdwFormLabelWithIconContainer
        controlId={controlId}
        label={label}
        isRequired={isRequired}
        labelWidth={LabelWidthTypes.MEDIUM}
        layout={ LayoutTypes.COLUMN}
    />
);